import { render } from "./Monthpicker.vue?vue&type=template&id=15617b7e&scoped=true&ts=true"
import script from "./Monthpicker.ts?vue&type=script&lang=ts"
export * from "./Monthpicker.ts?vue&type=script&lang=ts"

import "./Monthpicker.scss?vue&type=style&index=0&id=15617b7e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\OrlandoLiccardo\\work\\Monthpicker\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15617b7e"]])

export default __exports__